import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomGridComponent } from './custom-grid.component';
import { ColumnChooserService, EditService, ExcelExport, ExcelExportService, FilterService, GridModule, GroupService, PageService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ButtonModule, CheckBoxModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { BarcodeGeneratorModule } from '@syncfusion/ej2-angular-barcode-generator';
import { CustomDropDownListModule } from '../custom-drop-down-list/custom-drop-down-list.module';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { SkeletonModule } from '@syncfusion/ej2-angular-notifications';
import { NgxBarcodeModule } from 'src/app/services/ngx-barcode/ngx-barcode.module';
import { CustomDialogModule } from '../custom-dialog/custom-dialog.module';
import { CustomDatePickerModule } from '../custom-date-picker/custom-date-picker.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingAnimationModule } from "../loading-animation/loading-animation.module";



@NgModule({
  declarations: [
    CustomGridComponent
  ],
  imports: [
    CommonModule,
    GridModule,
    ButtonModule,
    SwitchModule,
    CheckBoxModule,
    ToolbarModule,
    TooltipModule,
    BarcodeGeneratorModule,
    CustomDropDownListModule,
    DropDownListModule,
    DialogModule,
    ButtonModule,
    SkeletonModule,
    NgxBarcodeModule,
    CustomDialogModule,
    CustomDatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingAnimationModule,
],
  exports: [
    CustomGridComponent
  ],
  providers: [
    PageService,
    SortService,
    FilterService,
    GroupService,
    EditService,
    ToolbarService,
    DialogModule,
    ColumnChooserService,
    ExcelExportService,
  ]
})
export class CustomGridModule { }
